export { CHAIN_NAMESPACES } from '@toruslabs/base-controllers';

const CONNECTOR_NAMESPACES = {
  EIP155: "eip155",
  SOLANA: "solana",
  CASPER: "casper",
  XRPL: "xrpl",
  MULTICHAIN: "multichain"
};

export { CONNECTOR_NAMESPACES };
